import { z } from 'zod'
import { textoObrigatorio } from './comum'

export const criarSetorSchema = z.object({
  nome: textoObrigatorio('nome do setor', 80),
  ativo: z.boolean().default(true),
})
export type CriarSetorEntrada = z.infer<typeof criarSetorSchema>

export const atualizarSetorSchema = z.object({
  nome: textoObrigatorio('nome do setor', 80).optional(),
  ativo: z.boolean().optional(),
})

export interface SetorMembroDto {
  usuarioId: string
  nome: string
  /** false = monitora o setor sem entrar no rodízio (4.7) */
  atende: boolean
}

export interface SetorDto {
  id: string
  nome: string
  ativo: boolean
  membros: SetorMembroDto[]
}
